import authorsData from '@/mockData/authors.json'

const state = {
    authors: authorsData,
}

const mutations = {
    ADD_AUTHOR(state, form) {
        state.authors.push(form)
    }
}

const actions = {
    addAuthor({ commit }, form) {
        commit('ADD_AUTHOR', form)
    }
}

const getters = {
    getData: state => state.authors
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
